
import common from './common';
import auth from './auth';
import legal from './legal';
import homepage from './homepage';
import contactForm from './contactForm';
import contactUs from './contactUs';
import referralOpportunity from './referralOpportunity';

export default {
  ...common,
  ...auth,
  ...legal,
  ...homepage,
  ...contactForm,
  ...contactUs,
  ...referralOpportunity,
};
